import PropTypes from 'prop-types';

import classes from './Subjects.module.css';

const Subjects = ({ productData }) => {
  return (
    <div className={classes.section}>
      {productData.RVOE && (
        <p className={classes.rvoeText}>{productData.RVOE}</p>
      )}
      <p className={classes.subjectsText}>Materias</p>
      {productData.periods.map(period => (
        <aside
          key={period.period}
          className={classes.periodContainer}
        >
          <span className={classes.periodText}>
            {period.period} <span>{period.periodText}</span>
          </span>
          {period.subject.map(subject => (
            <span className={classes.subject} key={subject}>
              {subject}
            </span>
          ))}
        </aside>
      ))}
    </div>
  );
};

Subjects.propTypes = {
  // eslint-disable-next-line react/require-default-props
  productData: PropTypes.object
};

export default Subjects;
